module.exports = __webpack_public_path__ + "custom-font.f35e2fdf.ttf";